import { useTheme as useThemeRoot } from '@ui-system/css/RootThemeProvider';

import { Theme } from './interfaces';

export const useTheme = (): Theme => useThemeRoot() as Theme;
